module.exports = __webpack_public_path__ + "img/shebao.730898d7.gif";